import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useOrderQueryFilters } from 'hooks';

import { ManageOrdersList } from '../ManageOrderList';

export const HoldCompletedOrders: React.FC = () => {
  useOrderQueryFilters();
  return (
    <ManageOrdersList
      tab={OrdersTab.HoldCompleted}
      additionalColumns={[
        AdditionalOrderColumn.HoldCompleted,
        AdditionalOrderColumn.Trader,
      ]}
    />
  );
};
